import { TypePolicies } from '@apollo/client';

const esgKpiPolicy: TypePolicies = {
  EsgKpi: {
    keyFields: false as const,
  },
};

export default esgKpiPolicy;
